import React from 'react'
import clsx from 'clsx'
import ScrollContainer from 'react-indiana-drag-scroll'
import { LazyLoadImage } from 'src/components/atoms'
import { HighlightData } from 'src/components/molecules/OCRHighlightOverlay/types'
import styles from './styles.module.scss'

export type ZoomableReceiptImageProps = {
  concatOriginal?: string
  separatedOriginal?: Array<string>
  resized?: string
  highlights?: HighlightData[]
  showHighlights?: boolean
  showHighlightSelector?: boolean
  onChangeHighlightEnabled?: (enabled: boolean) => void
  onLoaded?: () => void
} & React.StyledProps

const ZoomableReceiptImage: React.StyledFC<ZoomableReceiptImageProps> = ({
  concatOriginal,
  separatedOriginal,
  resized,
  highlights,
  showHighlights,
  showHighlightSelector,
  onChangeHighlightEnabled,
  className,
  onLoaded,
}: ZoomableReceiptImageProps) => {
  const onClickLink = () => {
    if (concatOriginal) {
      window.open(concatOriginal, '_blank')
    }
  }

  return (
    <div className={styles.a} onClick={onClickLink} role="presentation">
      <ScrollContainer
        className={clsx(styles.root, className, styles.grab)}
        hideScrollbars={false}
      >
        {separatedOriginal && resized && (
          <LazyLoadImage
            className={styles.img}
            sources={separatedOriginal}
            placeholder={resized}
            alt="レシート"
            highlights={highlights}
            showHighlights={showHighlights}
            showHighlightSelector={showHighlightSelector}
            onChangeHighlightEnabled={onChangeHighlightEnabled}
            onLoaded={onLoaded}
          />
        )}
      </ScrollContainer>
    </div>
  )
}

export default ZoomableReceiptImage
